import React, { useEffect, useState } from "react"
import { AiOutlineLink } from "react-icons/ai"
import { Button, Table, Input, Card, Tooltip } from "antd"

import Loading from "../layouts/Loading/Loading"

import { useDispatch, useSelector } from "react-redux"
import { getUsersForRpmFollowUpAction } from "../../redux/actions/rpmAction"

const { Search } = Input

const RPMPatientFollowUpList = () => {
  const dispatch = useDispatch()
  const { loading, rpmFollowUpUsers } = useSelector(state => state.rpmFollowUpUsers)
  const userInfo = useSelector(state => state.userInfo)
  const [data, setData] = useState([])
  const [serachedData, setSearchedData] = useState([])
  const [serachTerm, setSearchTerm] = useState("")

  useEffect(() => {
    const currentMonth = new Date().getMonth()
    if (userInfo?.userInfo?.orgId !== undefined) {
      currentMonth === 0
        ? dispatch(
            getUsersForRpmFollowUpAction(
              12,
              new Date().getFullYear() - 1,
              userInfo?.userInfo?.orgId
            )
          )
        : dispatch(
            getUsersForRpmFollowUpAction(
              new Date().getMonth(),
              new Date().getFullYear(),
              userInfo?.userInfo?.orgId
            )
          )
    }
  }, [dispatch, userInfo?.userInfo?.orgId])
  // console.log(rpmFollowUpUsers)

  // column for table
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo"
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
      render: name => <p className="text-capitalize wrap-text mb-0">{name}</p>
    },
    {
      title: "Action",
      render: ({ id }) => (
        <Tooltip title="Follow-up">
          <Button
            type="primary"
            shape="circle"
            icon={<AiOutlineLink size={22} />}
            onClick={() => (window.location.href = `/rpm-follow-up/${id}`)}
          />
        </Tooltip>
      )
    }
  ]

  useEffect(() => {
    const newData = []
    let sno = 1
    rpmFollowUpUsers?.map(({ firstName, middleName, lastName, userId }) => {
      middleName !== null
        ? newData.push({
            key: sno,
            sNo: sno,
            name: `${firstName} ${middleName} ${lastName}`,
            id: userId
          })
        : newData.push({ key: sno, sNo: sno, name: `${firstName} ${lastName}`, id: userId })
      sno += 1
      return userId
    })
    setData(newData)
  }, [rpmFollowUpUsers])

  // console.log('data',data)

  const handleSearch = term => {
    const prevData = data
    setSearchTerm(term?.toLowerCase())
    const newData = prevData.filter(item => item?.name?.toLowerCase().includes(term?.toLowerCase()))
    if (newData?.length) {
      setSearchedData(newData)
    } else {
      setSearchedData([])
    }
  }

  return loading ? (
    <div className="loaderLoading">
      <Loading />
    </div>
  ) : (
    <>
      <Card className="rounded-b-none">
        <div className="flex justify-between">
          <h3 className="text-xl">Patient's Treatment Follow Up</h3>
          <Search
            allowClear
            size="large"
            placeholder="Search"
            className="max-w-[350px]"
            onSearch={value => handleSearch(value)}
            onChange={e => handleSearch(e.target.value)}
          />
        </div>
      </Card>
      <Table
        columns={columns}
        dataSource={serachTerm ? serachedData : data}
        scroll={{ x: "max-content" }}
      />
    </>
  )
}

export default RPMPatientFollowUpList
